import BottomTabBar, { TAB_BAR_HEIGHT } from './BottomTabBar';

// Shared layout for the tab screens (Taxes / Cash flow / Expenses / You).
// Sticky header carrying the screen title, over the same page shell + 480px
// content column Dashboard uses. Header styling matches the StickyHeader
// pattern in Dashboard.js / IRSPayment.js. Renders the persistent BottomTabBar
// since all four are top-level tabs — which is also why there is no back
// affordance here: Home is one tap away in the bar below.
const TEXT1   = 'var(--ink)';
const SURFACE = 'var(--paper)';

export default function DetailScreen({ title, children }) {
  return (
    <div style={{ backgroundColor: SURFACE, minHeight: '100vh' }}>
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        height: 56, backgroundColor: 'var(--card)',
        borderBottom: '0.5px solid rgba(0,0,0,0.12)',
        display: 'flex', alignItems: 'center',
        padding: '0 20px', gap: 10,
      }}>
        <span style={{ fontFamily: 'var(--font-serif)', fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.3px', color: TEXT1 }}>
          {title}
        </span>
      </div>
      {/* Bottom padding clears the fixed BottomTabBar (height + breathing room + safe-area inset). */}
      <div style={{
        maxWidth: 480, margin: '0 auto', padding: '16px 16px 0',
        paddingBottom: `calc(${TAB_BAR_HEIGHT + 12}px + max(env(safe-area-inset-bottom), 8px))`,
      }}>
        {children}
      </div>
      <BottomTabBar />
    </div>
  );
}
